import { render, staticRenderFns } from "./ShowcaseSection.vue?vue&type=template&id=e6024180"
import script from "./ShowcaseSection.vue?vue&type=script&lang=js"
export * from "./ShowcaseSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports